import { FC } from 'react';
import leftArrow from 'assets/icons/arrow-left-border.svg';
import rightArrow from 'assets/icons/arrow-right-border.svg';

import styles from './styles.module.scss';

export const ScreenWidthStub: FC = () => {
  return (
    <div className={styles['stub']}>
      <img
        className={styles['stub__left-arrow']}
        src={leftArrow}
        alt="left-arrow"
      />
      <div className={styles['stub__header']}>
        Сделайте окно шире, <br />
        пожалуйста
      </div>
      <img
        className={styles['stub__right-arrow']}
        src={rightArrow}
        alt="left-arrow"
      />
    </div>
  );
};
